import { Col, Row } from 'antd'
import { camelCase, startCase } from 'lodash'
import './SectionSummary.style.less'

interface Props {
  data: any
}

function SectionSummary(props: Props) {
  return (
    <div className="section-summary-container ">
      <Row
        className="section-header-container report-page-break"
        justify={'space-between'}
      >
        <Col span={8}>
          <p className="header" style={{ textAlign: 'left' }}>
            Sections
          </p>
        </Col>
        <Col span={8}>
          <p className="header" style={{ textAlign: 'center' }}>
            Comment
          </p>
        </Col>
        <Col span={8}>
          <p className="header" style={{ textAlign: 'right' }}>
            Result
          </p>
        </Col>
      </Row>
      {props.data?.map((item, key) => {
        return (
          <Row
            key={key}
            className="section-value-container report-page-break"
            justify={'space-between'}
          >
            <Col span={8}>
              <p className="value" style={{ textAlign: 'left' }}>
                {key + 1}. {item?.title ?? startCase(camelCase(item.name))}
              </p>
            </Col>
            <Col span={8}>
              <p
                className="value"
                style={{ textAlign: 'left', whiteSpace: 'pre-line' }}
              >
                {item.comment}
              </p>
            </Col>
            <Col span={8}>
              <p
                className="value"
                style={{
                  textAlign: 'right',
                  color:
                    item.result == 'PASS'
                      ? '#65bf73'
                      : item.result == 'FAIL'
                      ? '#C03261'
                      : item.result == 'PENDING'
                      ? '#EF9747'
                      : '#848484',
                }}
              >
                {item.result}
              </p>
            </Col>
          </Row>
        )
      })}
    </div>
  )
}

export default SectionSummary
